import React from 'react'

 const About = () => {
  return (
    <>
      <h1 className='text-3xl text-purple-500 py-7 pl-10 md:pl-20'>From Pakistan Kpk 
       <span className='text-3xl text-yellow-500'>Malakand Divsion </span>
       District Buner
      </h1>
       
       <p className=' border-2 border-green-600 p-10 m-5'>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis temporibus quidem possimus enim deleniti. Magni, voluptatem recusandae saepe rem voluptatum asperiores similique mollitia facilis consectetur adipisci, totam neque aut. Eos ex ea officia optio deleniti omnis, quibusdam sed dolorem, enim reiciendis, nostrum odio officiis corrupti quisquam in dignissimos nam odit!
       </p>
    </>
  )
}
export default About;